(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._MediaViewer_1u5j4_1{display:flex;justify-content:center;align-items:center;width:100%;height:100%;padding:2rem}._MediaViewer_1u5j4_1 img{width:100%;height:100%;object-fit:contain}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { useSystemManager as p, useWindowsManager as l, AppsConfig as s, IMAGE_EXTENSIONS as t, App as u } from "@prozilla-os/core";
import { jsx as r } from "react/jsx-runtime";
import { useEffect as m } from "react";
const c = "_MediaViewer_1u5j4_1", f = {
  MediaViewer: c
};
function w({ file: e, close: o, setTitle: i }) {
  const { appsConfig: d } = p(), a = l();
  if (m(() => {
    e != null && (i == null || i(e.id));
  }, [e, i]), e == null) {
    const n = d.getAppByRole(s.APP_ROLES.fileExplorer);
    setTimeout(() => {
      n != null && (a == null || a.open(n.id, { path: "~/Pictures" })), o == null || o();
    }, 10);
    return;
  }
  return e.extension == null || !t.includes(e.extension) ? /* @__PURE__ */ r("p", { children: "Invalid file format." }) : e.source == null ? /* @__PURE__ */ r("p", { children: "File failed to load." }) : /* @__PURE__ */ r("div", { className: f.MediaViewer, children: /* @__PURE__ */ r("img", { src: e.source, alt: e.id, draggable: "false" }) });
}
const g = new u("Media Viewer", "media-viewer", w).setIconUrl("https://os.prozilla.dev/assets/apps/icons/media-viewer.svg").setRole(s.APP_ROLES.mediaViewer).setAssociatedExtensions(t).setCategory("Photo & video");
g.setMetadata({ name: "@prozilla-os/media-viewer", version: "1.1.15", author: "Prozilla" });
export {
  g as mediaViewer
};
//# sourceMappingURL=main.js.map
